import ContentDisposition from 'content-disposition'

import HTTP from '@/utils/http'
import userHelper from '@/utils/userHelper'
import { useBaseUrl } from '@/utils/http/hook'

// https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Sending_and_Receiving_Binary_Data
/**
 * Save binary file directly from Koa`s response.
 * Filename will be retrieved from response header `Content-Disposition`,
 * if it fails, filename `download` will be used.
 * @param {Object} response Koa response object.
 */
export const save = (response, excelName) => {
  const disposition = ContentDisposition.parse(response.headers['content-disposition'] || {})
  const filename = excelName || disposition.parameters.filename || 'download'

  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  })
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.setAttribute('download', filename)
    link.click()
    return link.href
  }
}

export async function downloadFile (url, filename, params) {
  if (userHelper.isIOSMobile()) {
    const link = document.createElement('a')
    link.href = useBaseUrl() + url
    link.target = '_blank'
    link.click()
  } else {
    const response = await HTTP.get(url, { responseType: 'arraybuffer', params })
    save(response, filename)
  }
}

export async function downloadDocFile (id) {
  return downloadFile(`/docs/${id}`)
}
